import ReactModal from 'react-modal';
import dayjs from 'dayjs';

import Button from 'atoms/button';
import { isNotEmptyArray } from 'util';

export default function RescheduleStatusModal({
  isOpen,
  setIsOpen,
  onClose,
  dateTimes,
  petName,
}) {
  if (!dateTimes) return null;

  const receivedTimes = dateTimes?.received;
  const requestedTimes = dateTimes?.requested?.map(
    (dateTime) => `${dateTime.date}T${dateTime.times[0]}`
  );

  const sentSuggestions = requestedTimes?.filter((time) =>
    receivedTimes?.includes(time)
  );
  const unavailableSuggestions = requestedTimes?.filter(
    (time) => !receivedTimes?.includes(time)
  );

  const hasSentSingleSuggestion =
    isNotEmptyArray(requestedTimes) && requestedTimes.length === 1;

  const handleDone = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={handleDone}
      className="reschedule-status-modal"
    >
      <div className="text-center flex-column align-center">
        <h2 className="mb-20 f26">
          {hasSentSingleSuggestion
            ? 'Reschedule confirmed'
            : 'Suggested times sent'}
        </h2>
        {dateTimes && hasSentSingleSuggestion ? (
          <p className="f15 mb-20">
            You have reschedule {petName}&apos;s appointment to{' '}
            <strong>
              {dayjs(requestedTimes[0]).format('dddd, MMMM D, h:mm a')}
            </strong>
          </p>
        ) : (
          <div className="flex-column align-start mb-20">
            {sentSuggestions?.length > 0 && (
              <div className="mb-15">
                <p className="f15">Suggested times sent for client approval:</p>
                <ul>
                  {sentSuggestions.map((time) => (
                    <li key={time} className="text-left">
                      <strong>
                        {dayjs(time).format('dddd, MMMM D, h:mm a')}
                      </strong>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {unavailableSuggestions?.length > 0 && (
              <>
                <p className="f15">Already booked suggested times:</p>
                <ul>
                  {unavailableSuggestions.map((time) => (
                    <li key={time} className="text-left c-red">
                      <strong>
                        {dayjs(time).format('dddd, MMMM D, h:mm a')}
                      </strong>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        )}
        <Button size="large" onClick={handleDone} text="Done" />
      </div>
    </ReactModal>
  );
}
